<template>
  <el-table :data="history" stripe style="width: 100%">
    <el-table-column sortable prop="tag" label="Objeto" align="center" />
    <el-table-column label="Alteração" prop="change" align="center" />
    <el-table-column prop="order_service_id" label="Numero da O.S." align="center" />
    <el-table-column prop="event_type" label="Detalhes" align="center">
      <template slot-scope="scope">
        {{ scope.row.event_type | formatDetails }}
      </template>
    </el-table-column>
    <el-table-column prop="responsible.name" label="Reponsável" align="center" />
    <el-table-column sortable prop="created_at" :label="$t('data')" align="center">
      <template slot-scope="scope">
        {{ scope.row.created_at | dateFormater }}
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import moment from 'moment';
export default {
  name: "OsDetailsHistoryTable",
  props: {
    history: Array
  },
  filters: {
    dateFormater(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }

    },

    formatDetails(data) {
      const options = {
        ['COLECT_CLIENT']: 'Coletado no cliente',
        ['DELIVERY_CUSTOMER']: 'Objetos recebidos na agência MaisEnvios',
        ['DELIVERY_CORREIOS']: 'Postado nos correios'
      }

      return options[data] || '-'
    },

    formatStatus(status) {
      const options = {
        ['1']: 'Aberta',
        ['2']: 'Impressa',
        ['3']: 'Encerrada'
      }

      return options[status]
    }
  },
}
</script>